import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { hasOwnPropertyTS } from '@components/utils';



const About = () => {
	const { t } = useTranslation('web');

	return (
		<div className='footer-menu about-section'>

			<Link to={NavigateRoutesEnum.about} className='disable-selection'>
				{t('layouts.footer.aboutSection.aboutUs')}
			</Link>

			<Link to={NavigateRoutesEnum.history} className='disable-selection'>
				{t('layouts.footer.aboutSection.history')}
			</Link>

			<Link to={NavigateRoutesEnum.partners} className='disable-selection'>
				{t('layouts.footer.aboutSection.partners')}
			</Link>

			<Link to={'#'} className='disable-selection' onClick={() => {
					if (hasOwnPropertyTS(window, 'Cookiebot')
						&& window.Cookiebot
						&& hasOwnPropertyTS(window.Cookiebot, 'show')
						&& window.Cookiebot.show) {
							(window.Cookiebot as any).show();
						}
				}}>
				{t('layouts.footer.aboutSection.changeCookiesConsent')}
			</Link>

			<br />

			<Link to={NavigateRoutesEnum.contact} className='disable-selection'>
				{t('layouts.footer.aboutSection.contact')}
			</Link>

			<p className='contact-phone-number'>{t('layouts.footer.aboutSection.phoneNumberLabel')} <span>{t('shared.contactPhoneNumber')}</span></p>
			
		</div>
	);
}

export default About;